import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowChevronDuoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M13.74 11.33L3.73998 0.33C3.36998 -0.0799998 2.73998 -0.11 2.32998 0.26C1.91998 0.63 1.88998 1.26 2.25998 1.67L11.65 12L2.25998 22.33C1.88998 22.74 1.91998 23.37 2.32998 23.74C2.73998 24.11 3.36998 24.08 3.73998 23.67L13.74 12.67C14.09 12.29 14.09 11.71 13.74 11.32V11.33Z"
        fill={color}
      />
      <path
        d="M23.74 11.33L13.74 0.33C13.37 -0.0799998 12.74 -0.11 12.33 0.26C11.92 0.63 11.89 1.26 12.26 1.67L21.65 12L12.26 22.33C11.89 22.74 11.92 23.37 12.33 23.74C12.74 24.11 13.37 24.08 13.74 23.67L23.74 12.67C24.09 12.29 24.09 11.71 23.74 11.32V11.33Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowChevronDuoIcon.displayName = 'ArrowChevronDuoIcon';
